import type { UserSelectionState } from "@/store/slices/userSelection/userSelection";
import { DateTime } from "luxon";

export const defaultUserSelection: any = {
  base: "GENPOP",
  statTest: "POP",
  periodType: "L180D",
  periodStartDate: DateTime.now().minus({ days: 180 }).toFormat("yyyy-MM-dd"),
  periodEndDate: DateTime.now().minus({ days: 1 }).toFormat("yyyy-MM-dd"),
  period: "P_M",
  postPeriodType: "L180D",
  postStartDate: DateTime.now().minus({ days: 180 }).toFormat("yyyy-MM-dd"),
  postEndDate: DateTime.now().minus({ days: 1 }).toFormat("yyyy-MM-dd"),
  mode: "POINT_IN_TIME",
  visualizationType: "",
  brand: null,
  brands: [],
  secondaryBrands: [],
  filters: [],
  market: null,
  markets: [],
  segments: [],
  groupedBy: "RESPONSE",
  questionOptions: [],
  ageRange: null,
  profileGroup: null,
  profileMetric: null,
  profileResponse: null,
  trendsMetric: null,
  trendsResponse: null,
  viewId: null,
};
